import { memo } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';

const UrologyExamination = ({
    selectedOnExamination,
    handleOnExaminationData,
}) => {
    let { urologyExamination } = selectedOnExamination;
    urologyExamination = urologyExamination || {};

    const handleChange = (field, value) => {
        const updatedData = { ...urologyExamination };

        // Handle nested fields (status or note)
        if (field.includes('.')) {
            const [mainField, subField] = field.split('.');
            updatedData[mainField] = {
                ...(updatedData[mainField] || {}),
                [subField]: value
            };
        } else {
            updatedData[field] = value;
        }

        handleOnExaminationData(updatedData, 'urologyExamination');
    };

    return (
            <div className="gyne-examination">
                <div className="title-gyne-examination">Digital Rectal Exam</div>
                <hr className="hr" />
            
            

            {/* Anal Sensation */}
            <Row className="mb-3 align-items-center">
                    <Col md={3} className="">
                    Anal Sensation:
                </Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="analSensation-normal"
                                label="Normal"
                                name="analSensation"
                                checked={(urologyExamination?.analSensation?.status || '') === 'normal'}
                                onClick={() =>
                                    handleChange(
                                        'analSensation.status',
                                        urologyExamination?.analSensation?.status === 'normal' ? '' : 'normal'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="analSensation-reduced"
                                label="Reduced"
                                name="analSensation"
                                checked={(urologyExamination?.analSensation?.status || '') === 'reduced'}
                                onClick={() =>
                                    handleChange(
                                        'analSensation.status',
                                        urologyExamination?.analSensation?.status === 'reduced' ? '' : 'reduced'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.analSensation?.note || ''}
                        onChange={(e) => handleChange('analSensation.note', e.target.value)}
                    />
                </Col>
            </Row>

            {/* Anal Tone */}
            <Row className="mb-3 align-items-center">
                    <Col md={3} className="">
                    Anal Tone:
                </Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="analTone-normal"
                                label="Normal"
                                name="analTone"
                                checked={(urologyExamination?.analTone?.status || '') === 'normal'}
                                onClick={() =>
                                    handleChange(
                                        'analTone.status',
                                        urologyExamination?.analTone?.status === 'normal' ? '' : 'normal'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="analTone-reduced"
                                label="Reduced"
                                name="analTone"
                                checked={(urologyExamination?.analTone?.status || '') === 'reduced'}
                                onClick={() =>
                                    handleChange(
                                        'analTone.status',
                                        urologyExamination?.analTone?.status === 'reduced' ? '' : 'reduced'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.analTone?.note || ''}
                        onChange={(e) => handleChange('analTone.note', e.target.value)}
                    />
                </Col>
            </Row>
            <Row className="mb-3 align-items-center">
                <Col md={3} className="label-text font-weight-bold">
                    Prostate
                </Col>
            </Row>

            {/* Prostate Size*/}
            <Row className="mb-3 align-items-center">
                <Col md={3} className="">
                    Size
                </Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="size-enlarged"
                                label="Enlarged"
                                name="size"
                                checked={(urologyExamination?.size?.status || '') === 'enlarged'}
                                onClick={() =>
                                    handleChange(
                                        'size.status',
                                        urologyExamination?.size?.status === 'enlarged' ? '' : 'enlarged'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="size-normal"
                                label="Normal"
                                name="size"
                                checked={(urologyExamination?.size?.status || '') === 'normal'}
                                onClick={() =>
                                    handleChange(
                                        'size.status',
                                        urologyExamination?.size?.status === 'normal' ? '' : 'normal'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.size?.note || ''}
                        onChange={(e) => handleChange('size.note', e.target.value)}
                    />
                </Col>
            </Row>

            {/* Consistency */}
            <Row className="mb-3 align-items-center">
                <Col md={3} className="">Consistency:</Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="consistency-firm"
                                label="Firm"
                                name="consistency"
                                checked={(urologyExamination?.consistency?.status || '') === 'firm'}
                                onClick={() =>
                                    handleChange(
                                        'consistency.status',
                                        urologyExamination?.consistency?.status === 'firm' ? '' : 'firm'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="consistency-hard"
                                label="Hard"
                                name="consistency"
                                checked={(urologyExamination?.consistency?.status || '') === 'hard'}
                                onClick={() =>
                                    handleChange(
                                        'consistency.status',
                                        urologyExamination?.consistency?.status === 'hard' ? '' : 'hard'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.consistency?.note || ''}
                        onChange={(e) => handleChange('consistency.note', e.target.value)}
                    />
                </Col>
            </Row>

            {/* Tenderness */}
            <Row className="mb-3 align-items-center">
                <Col md={3} className="">Tenderness:</Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="tenderness-present"
                                label="Present"
                                name="tenderness"
                                checked={(urologyExamination?.tenderness?.status || '') === 'present'}
                                onClick={() =>
                                    handleChange(
                                        'tenderness.status',
                                        urologyExamination?.tenderness?.status === 'present' ? '' : 'present'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="tenderness-absent"
                                label="Absent"
                                name="tenderness"
                                checked={(urologyExamination?.tenderness?.status || '') === 'absent'}
                                onClick={() =>
                                    handleChange(
                                        'tenderness.status',
                                        urologyExamination?.tenderness?.status === 'absent' ? '' : 'absent'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.tenderness?.note || ''}
                        onChange={(e) => handleChange('tenderness.note', e.target.value)}
                    />
                </Col>
            </Row>

            {/* Surface */}
            <Row className="mb-3 align-items-center">
                <Col md={3} className="">Surface:</Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="surface-smooth"
                                label="Smooth"
                                name="surface"
                                checked={(urologyExamination?.surface?.status || '') === 'smooth'}
                                onClick={() =>
                                    handleChange(
                                        'surface.status',
                                        urologyExamination?.surface?.status === 'smooth' ? '' : 'smooth'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="surface-irregular"
                                label="Irregular"
                                name="surface"
                                checked={(urologyExamination?.surface?.status || '') === 'irregular'}
                                onClick={() =>
                                    handleChange(
                                        'surface.status',
                                        urologyExamination?.surface?.status === 'irregular' ? '' : 'irregular'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.surface?.note || ''}
                        onChange={(e) => handleChange('surface.note', e.target.value)}
                    />
                </Col>
            </Row>

            {/* Nodularity */}
            <Row className="mb-3 align-items-center">
                <Col md={3} className="">Nodularity:</Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="nodularity-nodular"
                                label="Nodular"
                                name="nodularity"
                                checked={(urologyExamination?.nodularity?.status || '') === 'nodular'}
                                onClick={() =>
                                    handleChange(
                                        'nodularity.status',
                                        urologyExamination?.nodularity?.status === 'nodular' ? '' : 'nodular'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="nodularity-smooth"
                                label="Smooth"
                                name="nodularity"
                                checked={(urologyExamination?.nodularity?.status || '') === 'smooth'}
                                onClick={() =>
                                    handleChange(
                                        'nodularity.status',
                                        urologyExamination?.nodularity?.status === 'smooth' ? '' : 'smooth'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.nodularity?.note || ''}
                        onChange={(e) => handleChange('nodularity.note', e.target.value)}
                    />
                </Col>
            </Row>

            {/* Anal Mucosa */}
            <Row className="mb-3 align-items-center">
                <Col md={3} className="">Anal Mucosa:</Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="analMucosa-free"
                                label="Free"
                                name="analMucosa"
                                checked={(urologyExamination?.analMucosa?.status || '') === 'free'}
                                onClick={() =>
                                    handleChange(
                                        'analMucosa.status',
                                        urologyExamination?.analMucosa?.status === 'free' ? '' : 'free'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="analMucosa-fixed"
                                label="Fixed"
                                name="analMucosa"
                                checked={(urologyExamination?.analMucosa?.status || '') === 'fixed'}
                                onClick={() =>
                                    handleChange(
                                        'analMucosa.status',
                                        urologyExamination?.analMucosa?.status === 'fixed' ? '' : 'fixed'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.analMucosa?.note || ''}
                        onChange={(e) => handleChange('analMucosa.note', e.target.value)}
                    />
                </Col>
            </Row>

            {/* Upper Border */}
            <Row className="mb-3 align-items-center">
                <Col md={3} className="">Upper Border:</Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="upperBorder-reached"
                                label="Reached"
                                name="upperBorder"
                                checked={(urologyExamination?.upperBorder?.status || '') === 'reached'}
                                onClick={() =>
                                    handleChange(
                                        'upperBorder.status',
                                        urologyExamination?.upperBorder?.status === 'reached' ? '' : 'reached'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="upperBorder-cant-reached"
                                label="Can't Reach"
                                name="upperBorder"
                                checked={(urologyExamination?.upperBorder?.status || '') === 'cant-reached'}
                                onClick={() =>
                                    handleChange(
                                        'upperBorder.status',
                                        urologyExamination?.upperBorder?.status === 'cant-reached' ? '' : 'cant-reached'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.upperBorder?.note || ''}
                        onChange={(e) => handleChange('upperBorder.note', e.target.value)}
                    />
                </Col>
            </Row>

            {/* Median Sulcus */}
            <Row className="mb-3 align-items-center">
                <Col md={3} className="">Median Sulcus:</Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="medianSulcus-prominent"
                                label="Prominent"
                                name="medianSulcus"
                                checked={(urologyExamination?.medianSulcus?.status || '') === 'prominent'}
                                onClick={() =>
                                    handleChange(
                                        'medianSulcus.status',
                                        urologyExamination?.medianSulcus?.status === 'prominent' ? '' : 'prominent'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="medianSulcus-obliterated"
                                label="Obliterated"
                                name="medianSulcus"
                                checked={(urologyExamination?.medianSulcus?.status || '') === 'obliterated'}
                                onClick={() =>
                                    handleChange(
                                        'medianSulcus.status',
                                        urologyExamination?.medianSulcus?.status === 'obliterated' ? '' : 'obliterated'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.medianSulcus?.note || ''}
                        onChange={(e) => handleChange('medianSulcus.note', e.target.value)}
                    />
                </Col>
            </Row>

            <Row className="title">
                    <Col className="title-gyne-examination">External Genitalia</Col>
            </Row>
            <hr />

            {/* EUM */}
            <Row className="mb-3 align-items-center">
                <Col md={3} className="">
                    EUM:
                </Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="eum-normal"
                                label="Normal"
                                name="eum"
                                checked={(urologyExamination?.eum?.status || '') === 'normal'}
                                onClick={() =>
                                    handleChange(
                                        'eum.status',
                                        urologyExamination?.eum?.status === 'normal' ? '' : 'normal'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="eum-stemous"
                                label="Stemous"
                                name="eum"
                                checked={(urologyExamination?.eum?.status || '') === 'stemous'}
                                onClick={() =>
                                    handleChange(
                                        'eum.status',
                                        urologyExamination?.eum?.status === 'stemous' ? '' : 'stemous'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.eum?.note || ''}
                        onChange={(e) => handleChange('eum.note', e.target.value)}
                    />
                </Col>
            </Row>

            {/* Phallus */}
            <Row className="mb-3 align-items-center">
                <Col md={3} className="">
                    Phallus:
                </Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="phallus-normal"
                                label="Normal"
                                name="phallus"
                                checked={(urologyExamination?.phallus?.status || '') === 'normal'}
                                onClick={() =>
                                    handleChange(
                                        'phallus.status',
                                        urologyExamination?.phallus?.status === 'normal' ? '' : 'normal'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="phallus-plaque"
                                label="Plaque"
                                name="phallus"
                                checked={(urologyExamination?.phallus?.status || '') === 'plaque'}
                                onClick={() =>
                                    handleChange(
                                        'phallus.status',
                                        urologyExamination?.phallus?.status === 'plaque' ? '' : 'plaque'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.phallus?.note || ''}
                        onChange={(e) => handleChange('phallus.note', e.target.value)}
                    />
                </Col>
            </Row>

            {/* Ant Urethra */}
            <Row className="mb-3 align-items-center">
                <Col md={3} className="">
                    Ant Urethra:
                </Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="antUrethra-normal"
                                label="Normal"
                                name="antUrethra"
                                checked={(urologyExamination?.antUrethra?.status || '') === 'normal'}
                                onClick={() =>
                                    handleChange(
                                        'antUrethra.status',
                                        urologyExamination?.antUrethra?.status === 'normal' ? '' : 'normal'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="antUrethra-cordlike"
                                label="Cordlike"
                                name="antUrethra"
                                checked={(urologyExamination?.antUrethra?.status || '') === 'cordlike'}
                                onClick={() =>
                                    handleChange(
                                        'antUrethra.status',
                                        urologyExamination?.antUrethra?.status === 'cordlike' ? '' : 'cordlike'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.antUrethra?.note || ''}
                        onChange={(e) => handleChange('antUrethra.note', e.target.value)}
                    />
                </Col>
            </Row>

            {/* Scrutum */}
            <Row className="mb-3 align-items-center">
                <Col md={3} className="">
                    Scrutum:
                </Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="scrutum-normal"
                                label="Normal"
                                name="scrutum"
                                checked={(urologyExamination?.scrutum?.status || '') === 'normal'}
                                onClick={() =>
                                    handleChange(
                                        'scrutum.status',
                                        urologyExamination?.scrutum?.status === 'normal' ? '' : 'normal'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="scrutum-bisfid"
                                label="Bisfid"
                                name="scrutum"
                                checked={(urologyExamination?.scrutum?.status || '') === 'bisfid'}
                                onClick={() =>
                                    handleChange(
                                        'scrutum.status',
                                        urologyExamination?.scrutum?.status === 'bisfid' ? '' : 'bisfid'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.scrutum?.note || ''}
                        onChange={(e) => handleChange('scrutum.note', e.target.value)}
                    />
                </Col>
            </Row>

            {/* Testes */}
            <Row className="mb-3 align-items-center">
                <Col md={3} className="">
                    Testes:
                </Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="testes-normal"
                                label="Normal"
                                name="testes"
                                checked={(urologyExamination?.testes?.status || '') === 'normal'}
                                onClick={() =>
                                    handleChange(
                                        'testes.status',
                                        urologyExamination?.testes?.status === 'normal' ? '' : 'normal'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="testes-small"
                                label="Small"
                                name="testes"
                                checked={(urologyExamination?.testes?.status || '') === 'small'}
                                onClick={() =>
                                    handleChange(
                                        'testes.status',
                                        urologyExamination?.testes?.status === 'small' ? '' : 'small'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="testes-smaller"
                                label="Smaller"
                                name="testes"
                                checked={(urologyExamination?.testes?.status || '') === 'smaller'}
                                onClick={() =>
                                    handleChange(
                                        'testes.status',
                                        urologyExamination?.testes?.status === 'smaller' ? '' : 'smaller'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="testes-enlarged"
                                label="Enlarged"
                                name="testes"
                                checked={(urologyExamination?.testes?.status || '') === 'enlarged'}
                                onClick={() =>
                                    handleChange(
                                        'testes.status',
                                        urologyExamination?.testes?.status === 'enlarged' ? '' : 'enlarged'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.testes?.note || ''}
                        onChange={(e) => handleChange('testes.note', e.target.value)}
                    />
                </Col>
            </Row>


            {/* Epididymis */}
            <Row className="mb-3 align-items-center">
                <Col md={3} className="">
                    Epididymis:
                </Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="epididymis-tender"
                                label="Tender"
                                name="epididymis"
                                checked={(urologyExamination?.epididymis?.status || '') === 'tender'}
                                onClick={() =>
                                    handleChange(
                                        'epididymis.status',
                                        urologyExamination?.epididymis?.status === 'tender' ? '' : 'tender'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="epididymis-nontender"
                                label="Non Tender"
                                name="epididymis"
                                checked={(urologyExamination?.epididymis?.status || '') === 'non tender'}
                                onClick={() =>
                                    handleChange(
                                        'epididymis.status',
                                        urologyExamination?.epididymis?.status === 'non tender' ? '' : 'non tender'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.epididymis?.note || ''}
                        onChange={(e) => handleChange('epididymis.note', e.target.value)}
                    />
                </Col>
            </Row>

            {/* Vas */}
            <Row className="mb-3 align-items-center">
                <Col md={3} className="">
                    Vas:
                </Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="vas-normal"
                                label="Normal"
                                name="vas"
                                checked={(urologyExamination?.vas?.status || '') === 'normal'}
                                onClick={() =>
                                    handleChange(
                                        'vas.status',
                                        urologyExamination?.vas?.status === 'normal' ? '' : 'normal'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="vas-beaded"
                                label="Beaded"
                                name="vas"
                                checked={(urologyExamination?.vas?.status || '') === 'beaded'}
                                onClick={() =>
                                    handleChange(
                                        'vas.status',
                                        urologyExamination?.vas?.status === 'beaded' ? '' : 'beaded'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.vas?.note || ''}
                        onChange={(e) => handleChange('vas.note', e.target.value)}
                    />
                </Col>
            </Row>

            {/* Pampiniform Plexus */}
            <Row className="mb-3 align-items-center">
                <Col md={3} className="">
                    Pampiniform Plexus:
                </Col>
                <Col md={5}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="pampiniform-normal"
                                label="Normal"
                                name="pampiniformPlexus"
                                checked={(urologyExamination?.pampiniformPlexus?.status || '') === 'normal'}
                                onClick={() =>
                                    handleChange(
                                        'pampiniformPlexus.status',
                                        urologyExamination?.pampiniformPlexus?.status === 'normal' ? '' : 'normal'
                                    )
                                }
                            />
                        </Col>
                        <Col md={6}>
                            <Form.Check
                                type="radio"
                                id="pampiniform-engorged"
                                label="Engorged"
                                name="pampiniformPlexus"
                                checked={(urologyExamination?.pampiniformPlexus?.status || '') === 'engorged'}
                                onClick={() =>
                                    handleChange(
                                        'pampiniformPlexus.status',
                                        urologyExamination?.pampiniformPlexus?.status === 'engorged' ? '' : 'engorged'
                                    )
                                }
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.pampiniformPlexus?.note || ''}
                        onChange={(e) => handleChange('pampiniformPlexus.note', e.target.value)}
                    />
                </Col>
            </Row>

            <hr className='hr'/>

            {/* Show Biliary System Picture */}
            <Row className="mb-3 align-items-center">
                <Col md={4} className="">
                    Show Biliary System Picture:
                </Col>
                <Col md={4}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="checkbox"
                                id="show-biliary-picture"
                                label="Show"
                                checked={urologyExamination?.showBiliaryPicture?.status || false}
                                onChange={(e) => handleChange('showBiliaryPicture.status', e.target.checked)}
                            />
                        </Col>
                        <Col md={6}>
                            <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => {
                                    handleChange('showBiliaryPicture.status', false);
                                }}
                            >
                                Clear
                            </Button>
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.showBiliaryPicture?.note || ''}
                        onChange={(e) => handleChange('showBiliaryPicture.note', e.target.value)}
                    />
                </Col>
            </Row>

            {/* Show Digestive System Picture */}
            <Row className="mb-3 align-items-center">
                <Col md={4} className="">
                    Show Digestive System Picture:
                </Col>
                <Col md={4}>
                    <Row>
                        <Col md={6}>
                            <Form.Check
                                type="checkbox"
                                id="show-digestive-picture"
                                label="Show"
                                checked={urologyExamination?.showDigestivePicture?.status || false}
                                onChange={(e) => handleChange('showDigestivePicture.status', e.target.checked)}
                            />
                        </Col>
                        <Col md={6}>
                            <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => {
                                    handleChange('showDigestivePicture.status', false);
                                }}
                            >
                                Clear
                            </Button>
                        </Col>
                    </Row>
                </Col>
                <Col md={4}>
                    <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Note"
                        className="form-control-sm"
                        style={{ height: '33px', width: '100%' }}
                        value={urologyExamination?.showDigestivePicture?.note || ''}
                        onChange={(e) => handleChange('showDigestivePicture.note', e.target.value)}
                    />
                </Col>
            </Row>

            </div>
    );
};

export default memo(UrologyExamination);